import customer from './customer'
import user from './user'
import auth from './auth'
import country from './country'
import city from './city'
import entity from './entity'
import permission from './permission'
import subscription from './subscription'
import consumer from './consumer'
import group from './group'
import zone from './Zone'
import meter from './Meter'
import cardPermission from './cardPermission'
import card from './card'
import consumption from './consumption'
import stats from './stats'
import topUp from './topUp'
import payBack from './payBack'
import setting from './setting'
import transaction from './transaction'
import groupOfMeter from './GroupOfMeter'

const resources = {
  customer,
  country,
  card,
  cardPermission,
  city,
  entity,
  user,
  auth,
  permission,
  subscription,
  consumer,
  group,
  zone,
  meter,
  consumption,
  stats,
  topUp,
  groupOfMeter,
  setting,
  payBack,
  transaction,
}
export default resources
